import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {ellipsize} from 'util/NameUtil';

import {LookupStepInfo} from './LookupConfigModalConstants';
import {LOOKUP_CHIP} from './LookupConfigStyling';
import {getIconForLookupStepInfo, getStepDisplayInfo} from './LookupConfigUtils';

interface LookupStepErrorChipProps {
  className?: string;
}

function LookupStepErrorChip(props: LookupStepErrorChipProps): JSX.Element {
  return (
    <Chip
      negative={true}
      className={classNames(css(styles.lookupChip), props.className)}
      size={ChipSize.TABLE_CELL}
      text="Missing value"
    />
  );
}

interface LookupStepChipProps {
  className?: string;
  hasError?: boolean;
  lookupStepInfo: LookupStepInfo;
  shouldFadeChip?: boolean;
  shouldParenthesize?: {open: boolean; close: boolean};
}

export default function LookupStepChip(props: LookupStepChipProps): JSX.Element {
  if (props.hasError) {
    return <LookupStepErrorChip className={props.className} />;
  }
  const icon = props.lookupStepInfo.iconToOverrideDefault || getIconForLookupStepInfo(props.lookupStepInfo);
  const {name, isArchived, tooltip, isDeleted} = getStepDisplayInfo(props.lookupStepInfo);
  return (
    <Tooltip disabled={tooltip == null} title={tooltip != null ? tooltip : ''}>
      {props.shouldParenthesize?.open && '( '}
      <Chip
        faded={props.shouldFadeChip ?? isArchived}
        negative={isDeleted}
        className={classNames(css(styles.lookupChip), props.className)}
        icon={icon}
        size={ChipSize.TABLE_CELL}
        text={ellipsize(name, 30)}
      />
      {props.shouldParenthesize?.close && ' )'}
      {props.lookupStepInfo.collapsingLookupSteps && <span className={css(styles.lookupChip)}>(Latest)</span>}
    </Tooltip>
  );
}

const styles = StyleSheet.create({lookupChip: LOOKUP_CHIP});
